/**
 * Created by Ning Jiang on 2017-09-25.
 */
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {TimelineLite, TimelineMax} from "gsap";
import {TeslaGameAssets} from "../../TeslaGameAssets";
import {TeslaSoundConfig} from "../../TeslaSoundConfig";

export class TeslaCollectLight extends PIXI.Container {
    private _loop:TimelineMax;

    get isOn():boolean {
        return this._isOn;
    }

    private _ballAnimation:TimelineSprite;
    private _isOn:boolean;

    constructor() {
        super();
        this._ballAnimation = new TimelineSprite(GameResources.getTextures(TeslaGameAssets.COLLECT_BALL_ANIMATION), 30);
        this.addChild(this._ballAnimation);
        this.turnOff();
    }

    public turnOff() {
        this._isOn = false;
        this.stopLoop();
        this._ballAnimation.setFrame(0);
    }


    public getTurnOnAnimation(isRestore:boolean = false):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add(() => this._isOn = true);
        if(isRestore) {
            tl.add([
                this._ballAnimation.getAnimation([0, 4])
            ]);
        } else {
            tl.add([
                () => SlotGame.sound.playEffect(TeslaSoundConfig.instance.FS_WILD_BOUNCE),
                this._ballAnimation.getAnimation([0, 4])
            ]);
        }

        tl.add(() => this.startLoop());
        return tl;
    }

    public getTurnOffAnimation():TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        if(this._isOn) {
            tl.add(() => this._isOn = false);
            tl.add(() => this.stopLoop());
            tl.add([
                this.playWildReleaseSound(),
                this._ballAnimation.getAnimation([13, 16])
            ]);
            tl.add(this._ballAnimation.getAnimation([0, 0]));
        } else {
            tl.add(() => this.turnOff());
        }
        return tl;
    }

    private startLoop() {
        this.stopLoop();
        this._loop = new TimelineMax({repeat : -1});
        this._loop.add(this._ballAnimation.getAnimation([5, 12]));
    }

    private stopLoop() {
        if(this._loop && this._loop.isActive()) {
            this._loop.pause();
            this._loop.kill();
        }
    }

    public getIntro():TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add(this._ballAnimation.getAnimation());
        tl.add(this._ballAnimation.getAnimation([0, 0]));
        return tl;
    }

    private playWildReleaseSound():TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add(() => SlotGame.sound.playEffect(TeslaSoundConfig.instance.FS_WILD_RELEASE));

        return tl;
    }

}